import { usePapaParse } from 'react-papaparse';
//const Papa = require('papaparse');

export function convertAmount(amount, fraction) {
    if (amount === "NaN" || amount === 0) {
        //console.log("Amount is: " + amount);
        amount = "0.00";
    }
    //console.log("Amount is: " + amount);
    return amount.toLocaleString('en-AU', { minimumFractionDigits: fraction, maximumFractionDigits: fraction })
}

function fixDashes(csvobj) {
    for (let i = 0; i < csvobj.length; i++) {
        for (let j = 0; j < csvobj[i].length; j++) {
            //console.log(csvobj[i][j]);
            csvobj[i][j] = csvobj[i][j].trim();
            if (csvobj[i][j] === '-') {
                csvobj[i][j] = '0.00';
            }
        }
    }
    return csvobj;
}

function date2iso(dt, fmt) {
    // normalize the date from dd-mm-yyyy or dd/mm/yyyy to yyyy-mm-dd
    // date separators
    // / – oblique stroke (slash)
    // . – full stop, dot or point (period)
    // - – hyphen (dash)
    // ' ' – space
    var separator;
    dt = dt.trim();
    if (dt.toLowerCase().indexOf('date') !== -1) {
        //console.log("Skipping - unknown delimiter for: " + dt);
        return 'header';
    }
    if (dt.split('-').length === 3) {
        separator = '-';
    } else if (dt.split('/').length === 3) {
        separator = '/';
    } else if (dt.split('.').length === 3) {
        separator = '.';
    } else if (dt.split(' ').length === 3) {
        separator = ' ';
    } else {
        //console.log("Unknown delimiter for: " + dt);
        return "header";
    }
    var parts = dt.split(separator);
    // make sure to add leading '0' to day and month
    for (let p = 0; p < parts.length; p++) {
        if (parts[p].length === 1) {
            parts[p] = '0' + parts[p];
        }
    }
    // get the selected format
    //console.log(fmt);
    //let bad = false;
    switch (fmt) {
        case 'dd mm yyyy':
            if (parseInt(parts[1]) > 12 ) {
                alert("Invalid date format selection");
                return true;
            }
            return parts[2] + '-' + parts[1] + '-' + parts[0];
        case 'mm dd yyyy':
            if (parseInt(parts[0]) > 12 ) {
                alert("Invalid date format selection");
                return true;
            }
            return parts[2] + '-' + parts[0] + '-' + parts[1];
        case 'yyyy mm dd':
            if (parts[0].length > 3 ) {
                alert("Invalid date format selection");
                return true;
            }
            return parts[0] + '-' + parts[1] + '-' + parts[2];
        default:
            return parts[2] + '-' + parts[1] + '-' + parts[0];
    }
}

function logit(activity) {
    // log an entry in the usage table
    //robj['email'],robj['code'], datetime.today().strftime('%Y-%m-%d %H:%M:%S'),robj['activity'],
    var pdata = {
        email: 'anon@react.fxfortax.com',
        code: '9999',
        activity: activity,
        date: new Date().toISOString().slice(0, 10),
    }

    let URL = 'api/usage';
    if (process.env.NODE_ENV === 'development') {
        URL = 'http://localhost:8081/api/usage';
    }
    fetch(URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(pdata),
    })
    .then(response => response.json())
    .then(data => {
        // Success callback
        // You can add any success handling code here if needed
    })
    .catch(error => {
        // Error handling
        console.error('Error:', error);
    });
}

function analyzeCsv(csvlines) {
    // Check the max number of fields in the sample records.
    // We no longer error if there's a mismatch, because we truncate to the 
    // first 4 columns anyway, and bank extracts often have trailing empty commas.
    var max_length = 0;
    for (let i = 0; i < csvlines.length; i++) {
        let fields = csvlines[i].split('|');
        if (fields.length > max_length) {
            max_length = fields.length;
        }
    }
    return max_length;
}

function validateCsvPreview(csvobj, num_fields) {
    const errors = [];

    // Must have at least 3 columns
    if (!num_fields || num_fields < 3) {
        errors.push('File must have at least 3 columns: Date, Description, Amount.');
        return { isValid: false, errors }; // can't check further
    }

    // Find first data row (skip header if present)
    const startRow = (csvobj[0] && csvobj[0][0] &&
        csvobj[0][0].toLowerCase().includes('date')) ? 1 : 0;

    if (csvobj.length <= startRow) {
        errors.push('File appears to be empty or contains only a header row.');
        return { isValid: false, errors };
    }

    const firstRow = csvobj[startRow];

    // Validate date column (col 0)
    const dateVal = (firstRow[0] || '').trim().replace(/^"|"$/g, '');
    const dateRegex = /^\d{1,4}[\-\/\.\s]\d{1,2}[\-\/\.\s]\d{1,4}$/;
    if (!dateRegex.test(dateVal)) {
        errors.push(`Column 1 (Date): "${dateVal}" does not look like a date. Expected formats: dd/mm/yyyy, mm/dd/yyyy, or yyyy-mm-dd.`);
    }

    // Validate amount column (col 2)
    const amtVal = (firstRow[2] || '').trim().replace(/^"|"$/g, '').replace(/,/g, '');
    if (isNaN(parseFloat(amtVal)) || amtVal === '') {
        errors.push(`Column 3 (Amount): "${firstRow[2]}" is not a valid number.`);
    }

    return { isValid: errors.length === 0, errors };
}
export function HandleFileUpload(csvfile, basisObj = {}, callback, confirmFn) {
    const { readString } = usePapaParse();

    if (csvfile.size === 0) {
        alert('Please select a file to upload.');
        return false;
    } else if (csvfile.size > 100000) {
        alert("Max file size is 100 KB. Uploaded file size is " + csvfile.size / 1000 + "KB.");
        return false
    }
    // empty out ant DOM elements

    var csvobj;
    readString(csvfile, {
        worker: true,
        skipEmptyLines: 'greedy',
        comment: '#',
        complete: async (results) => {
            //console.log(results);
            // now parse and validate the csv files and send the ajax call to get the rates
            logit('File uploaded: '+csvfile.name);
            csvobj = results.data;
            let parts = csvobj.toSpliced(10);
            let csvtext = [];
            for (let p = 0; p < parts.length; p++) {
                csvtext.push('"' + parts[p].join('|') + '"');
            }
            // save it in the AnalyzeCsv function
            var num_fields = analyzeCsv(csvtext);

            const validation = validateCsvPreview(csvobj, num_fields);
            const confirmResult = confirmFn
                ? await confirmFn({ text: csvtext.join('\n'), ...validation })
                : window.confirm(csvtext.join('\n'));
            if (!confirmResult) {
                return false;
            }

            // Truncate each row to at most 4 columns — ignore any extra columns beyond Date, Description, Amount, Rate
            if (num_fields > 4) {
                csvobj = csvobj.map(row => row.slice(0, 4));
                num_fields = 4;
            }

            // cleanup any amounts that are '-' and replace them with 0.00
            basisObj = basisObj.basisObj;
            // lets convert the dates to a standard format
            // the fmt referes to the selected data format - mm dd yyyy

            // skip header line
            if (csvobj[0][0].toLowerCase().indexOf('date') !== -1) {
                csvobj.shift();
            }

            // wrong FMT - get the format from the DOM
            var fmt = document.getElementById('dateformat').innerText;
            //console.log(fmt);

            for (let i = 0; i < csvobj.length; i++) {
                csvobj[i][0] = date2iso(csvobj[i][0], fmt);
                if (csvobj[i][0] === true) {
                    alert('Invalid date format');
                    return false;
                }
            }
            //  NOW lets forcefully sort it Newest-First (Descending) immediately after validation
            csvobj.sort((a, b) => {
                return new Date(b[0]) - new Date(a[0]);
            });
            //console.log(JSON.stringify(csvobj));
            csvobj = fixDashes(csvobj);
            if (num_fields > 3 && !isNaN(parseFloat(csvobj[1][3]))) { // the 4th field is the rate
                for (var i = 0; i < csvobj.length; i++) {
                    // get the exchange rate for the date
                    let amt = parseFloat(csvobj[i][2].replace(/,/g, ''));
                    let rate = parseFloat(csvobj[i][3].replace(/,/g, ''));
                    if (isNaN(rate) || isNaN(amt)) {
                        i++;
                        alert('Invalid amount or rate on line: ' + i);
                        return false;
                    }
                    //console.log(csvobj[i][2], amt, csvobj[i][3], rate);
                    csvobj[i][3] = convertAmount(rate, 6)
                    csvobj[i][4] = convertAmount(rate * amt, 6);
                }
                callback(csvobj);
            } else {
            // force truncation to 3 elements per csvobj row
            csvobj = csvobj.map(row => row.slice(0, 3));
            //console.log(JSON.stringify(csvobj)); // No NaN values here
            switch (basisObj.basis) {
                case 'Daily': // 1
                    for (let i = 0; i < csvobj.length; i++) {
                        basisObj.period.push(csvobj[i][0]);
                    }
                    break;
                case 'Monthly': // 2
                    for (let i = 0; i < csvobj.length; i++) {
                        let dt = csvobj[i][0].slice(0, 7);
                        //console.log(dt);
                        if (basisObj.period.indexOf(dt) === -1) {
                            basisObj.period.push(dt);
                        }
                    }
                    break;
                case 'Quarterly': // 3
                    // loop over the csvobj and extract the month/year fields from the date
                    for (let i = 0; i < csvobj.length; i++) {
                        let dt = csvobj[i][0].split('-');
                        let tdate = dt[0] + '-' + dt[1];
                        // get a unique list of year-months
                        if (basisObj.period.indexOf(tdate) === -1) {
                            basisObj.period.push(tdate);
                        }
                    }
                    break;
                case 'Calendar year': // 4
                    // the average value of the currency for the year is used
                    for (let i = 0; i < csvobj.length; i++) {
                        let tdate = csvobj[i][0].split('-')[0];
                        //let tdate = dt[0];
                        // get a unique list of years
                        if (basisObj.period.indexOf(tdate) === -1) {
                            basisObj.period.push(tdate);
                        }
                    }
                    break;
                case 'Financial year': // 5
                    // MUST read the Year end value and calculate based on that
                    // loop over the csvobj and extract the month/year fields from the date
                    for (let i = 0; i < csvobj.length; i++) {
                        let tdate = csvobj[i][0].split('-')[0];
                        //let tdate = dt[0]; // the year only
                        if (basisObj.period.indexOf(tdate) === -1) {
                            basisObj.period.push(tdate);
                        }
                    }
                    // but we also need to add the year-end month
                    if (parseInt(basisObj.yearend) === 0) {
                        alert('Please select the Financial year end - month.');
                        return false;
                    }
                    break;
                default:
                    alert('Please select a basis for the conversion.');
                    return false;
            }
            //console.log(basisObj);
            let jsonData = JSON.stringify(basisObj)

            let URL = 'api/exrates';
            if (process.env.NODE_ENV === 'development') {
                URL = 'http://localhost:8081/api/exrates';
            }
            const xhr = new XMLHttpRequest()
            xhr.open("POST", URL, true)
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.onreadystatechange = () => {
                if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
                    var rates = JSON.parse(xhr.response);
                    //console.log(rates);
                    // build the whole object and return it.
                    var previous_rate;
                    var daterange;
                    var ranges;
                    switch (basisObj.basis) {
                        case 'Daily':
                            // loop over the csvobj and collect the dates
                            for (let i = 0; i < csvobj.length; i++) {
                                // get the exchange rate for the date
                                let rate = rates[csvobj[i][0]];
                                //console.log(csvobj[i][0], rate);
                                if (rate === null || rate === undefined) {
                                    rate = previous_rate;
                                } else {
                                    previous_rate = rate;
                                }
                                let amt = parseFloat(csvobj[i][2].replace(/,/g, ''));
                                if (isNaN(rate) || isNaN(amt)) {
                                    i++;
                                    alert('Invalid amount or rate on line: ' + i);
                                    return false;
                                }
                                csvobj[i][2] = convertAmount(amt, 2)
                                csvobj[i].push(convertAmount(rate, 6));
                                csvobj[i].push(convertAmount(rate * amt, 6));
                            }
                            //console.log(csvobj);
                            break;
                        case 'Monthly':
                            // loop over the csvobj and extract the month/year fields from the date
                            let monthlist = Object.keys(rates);
                            var dobj = [];
                            for (let m = 0; m < monthlist.length; m++) {
                                let firstday = new Date(monthlist[m])
                                let lastday = new Date(firstday.getFullYear(), firstday.getMonth() + 1, 1)
                                dobj.push([new Date(firstday.toISOString().slice(0, 10)), new Date(lastday.toISOString().slice(0, 10))])
                            }

                            for (let i = 0; i < csvobj.length; i++) {
                                let dt = new Date(csvobj[i][0]);
                                let rate = 0;
                                for (let j = 0; j < dobj.length; j++) {
                                    if (dobj[j][1].getTime() >= dt.getTime() && dobj[j][0].getTime() <= dt.getTime()) {
                                        rate = rates[dobj[j][1].toISOString().slice(0, 7)]
                                        break;
                                    }
                                }
                                if (rate === 0) {
                                    continue;
                                }
                                let amt = parseFloat(csvobj[i][2].replace(/,/g, ''));
                                if (isNaN(rate) || isNaN(amt)) {
                                    i++;
                                    alert('Invalid amount or rate on line: ' + i);
                                    return false;
                                }
                                csvobj[i][2] = convertAmount(amt, 2)
                                previous_rate = rate;
                                csvobj[i].push(convertAmount(rate, 6));
                                csvobj[i].push(convertAmount(rate * amt, 6));
                            }
                            //console.log(csvobj);
                            break;
                        case 'Quarterly':
                            for (let d = 0; d < daterange.length; d++) {
                                let range = daterange[d].split(':');
                                let start = new Date(range[0]);
                                let end = new Date(range[1]);
                                ranges.push([start, end])
                            }
                            // now compare the dates in the csvobj with the ranges

                            for (let i = 0; i < csvobj.length; i++) {
                                let dt = new Date(csvobj[i][0]);
                                let rate;
                                for (let j = 0; j < ranges.length; j++) {
                                    if (dt.getTime() >= ranges[j][0].getTime() && dt.getTime() <= ranges[j][1].getTime()) {
                                        rate = rates[ranges[j][0].toISOString().slice(0, 10) + ':' + ranges[j][1].toISOString().slice(0, 10)]
                                        break;
                                    }
                                }
                                if (!rate) {
                                    rate = previous_rate;
                                }
                                //let amt = parseFloat(csvobj[i][0].replace(/,/g, ''));
                                let amt = parseFloat(csvobj[i][2].replace(/,/g, ''));
                                if (isNaN(rate) || isNaN(amt)) {
                                    i++;
                                    alert('Invalid amount or rate on line: ' + i);
                                    return false;
                                }
                                csvobj[i][2] = convertAmount(amt, 2)
                                previous_rate = rate;
                                csvobj[i].push(convertAmount(rate, 6));
                                csvobj[i].push(convertAmount(rate * amt, 6));

                            }
                            //console.log(JSON.stringify(csvobj));
                            break;
                        case 'Calendar year':
                            var range = [];
                            for (let d = 0; d < daterange.length; d++) {
                                let r = daterange[d].split(':');
                                let start = new Date(r[0]);
                                let end = new Date(r[1]);
                                range.push([start, end])
                            }
                            for (let i = 0; i < csvobj.length; i++) {
                                let dt = new Date(csvobj[i][0]);
                                let rate;
                                for (let j = 0; j < range.length; j++) {
                                    if (dt.getTime() >= range[j][0].getTime() && dt.getTime() <= range[j][1].getTime()) {
                                        rate = rates[range[j][0].toISOString().slice(0, 10) + ':' + range[j][1].toISOString().slice(0, 10)]
                                        break;
                                    }
                                }
                                if (!rate) {
                                    rate = previous_rate;
                                }
                                let amt = parseFloat(csvobj[i][2].replace(/,/g, ''));
                                if (isNaN(rate) || isNaN(amt)) {
                                    i++;
                                    alert('Invalid amount or rate on line: ' + i);
                                    return false;
                                }
                                csvobj[i][2] = convertAmount(amt, 2)
                                previous_rate = rate;
                                csvobj[i].push(convertAmount(rate, 6));
                                csvobj[i].push(convertAmount(rate * amt, 6));
                            }
                            break;
                        case 'Financial year':
                            for (let d = 0; d < daterange.length; d++) {
                                let range = daterange[d].split(':');
                                let start = new Date(range[0]);
                                let end = new Date(range[1]);
                                ranges.push([start, end])
                            }
                            // now compare the dates in the csvobj with the ranges

                            for (let i = 0; i < csvobj.length; i++) {
                                let dt = new Date(csvobj[i][0]);
                                let rate;
                                for (let j = 0; j < ranges.length; j++) {
                                    if (dt.getTime() >= ranges[j][0].getTime() && dt.getTime() <= ranges[j][1].getTime()) {
                                        rate = rates[ranges[j][0].toISOString().slice(0, 10) + ':' + ranges[j][1].toISOString().slice(0, 10)]
                                        break;
                                    }
                                }
                                if (!rate) {
                                    rate = previous_rate;
                                }
                                let amt = parseFloat(csvobj[i][2].replace(/,/g, ''));
                                if (isNaN(rate) || isNaN(amt)) {
                                    i++;
                                    alert('Invalid amount or rate on line: ' + i);
                                    return false;
                                }
                                csvobj[i][2] = convertAmount(amt, 2)
                                previous_rate = rate;
                                csvobj[i].push(convertAmount(rate, 6));
                                csvobj[i].push(convertAmount(rate * amt, 6));
                            }
                            //console.log(csvobj);
                            break;
                        default:
                            return false;
                    }
                    callback(csvobj);
                }
            }
            xhr.send(jsonData);
            }
        }
    });
};

//export function TestExport(tableid, fileObject) {
//    // calculate filename
//    //var file = document.getElementById('csvfile').files[0];
//    var parts = fileObject.name.split('.');
//    console.log(parts);
//}

export function HandleExport(tableid, fileObject, Obj) {
    // calculate filename
    var output;
    var fname;
    var parts = fileObject.name.split('.');
    var ft = parts.pop();
    var fn = parts.join('.');
    if (tableid === "base-transactions") {
        output = Table2csv(tableid);
        fname = fn + '.' + Obj.basisObj.foreign_currency + '-' + Obj.basisObj.functional_currency + '.' + Obj.basisObj.basis + '.base.' + ft;
    } else {
        output = "Gain/Loss tables";
        output += "\n\nClosing balance\n";
        output += Table2csv("closing-balance");
        output += '\n\nGain/loss\n';
        output += Table2csv("gl-transactions");
        fname = fn + '.' + Obj.basisObj.foreign_currency + '-' + Obj.basisObj.functional_currency + '.' + Obj.basisObj.basis + '.gl.' + ft;
    }
    var blob = new Blob([output], { type: 'text/csv;charset=utf-8;' });

    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, fname);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fname);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}

export function Table2csv(tableid) {
    // hand rolled converter to convert HTML table to CSV format
    // this is needed because the built in CSV export in DataTables
    // does not work with the Bootstrap styling
    var csv = [];
    var table = document.getElementById(tableid);

    // header
    var headerRow = table.querySelector('tr');
    if (headerRow) {
        var row = [];
        headerRow.querySelectorAll('th').forEach(function (th) {
            row.push('"' + th.textContent.trim() + '"');
        });
        csv.push(row.join(","));
    }

    // body
    table.querySelectorAll('tr').forEach(function (tr, index) {
        // skip the first row (header)
        if (index === 0) return;

        var row = [];
        tr.querySelectorAll('td').forEach(function (td) {
            row.push('"' + td.textContent.trim() + '"');
        });
        if (row.length > 0) {
            csv.push(row.join(","));
        }
    });

    // console.log(csv);
    return csv.join("\n");
}